import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {connect} from "react-redux";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation, withTranslation, Trans } from "react-i18next";




function Success () {
    const { t, i18n } = useTranslation();
    
    return (
        <React.Fragment>
            <Typography variant="h5" gutterBottom>
                {t('Bedankt voor je aanvraag')}.
            </Typography>
            <Typography variant="subtitle1">
                {t('Je aanvraag is succesvol verzonden. We controleren je aanvraag waarna je een afspraak kan inboeken')}.
            </Typography>
        </React.Fragment>
    );
}


export default Success;